import React from "react";

import {
  Box,
  IconButton,
  IconButtonProps,
  useColorModeValue,
} from "@chakra-ui/react";

import { CircledUpArrowIcon } from "icons";
import { useBackToTop } from "contexts/BackToTopProvider";

const BACK_TO_TOP_FAB_SIZE = 40;

const FAB_MARGIN = 16;

const BackToTopFAB = ({
  right = `${FAB_MARGIN}px`,
  isVisible = false,
  children,
  ...props
}: React.PropsWithChildren<
  Omit<IconButtonProps, "aria-label"> & {
    isVisible: boolean;
  }
>): React.ReactElement => {
  const bg = useColorModeValue("white", "grey.500");
  const { scrollToTop } = useBackToTop();
  return (
    <Box position="relative">
      {children}
      {isVisible && (
        <Box position="fixed" bottom="0" right={right} pointerEvents="none">
          <IconButton
            icon={
              <CircledUpArrowIcon
                color="grey.700"
                boxSize={`${BACK_TO_TOP_FAB_SIZE}px`}
              />
            }
            aria-label="Back to top"
            isRound
            variant="link"
            position="sticky"
            pointerEvents="all"
            onClick={scrollToTop}
            top={`calc(100% - ${BACK_TO_TOP_FAB_SIZE + FAB_MARGIN}px)`}
            {...props}
            bg={bg}
          />
        </Box>
      )}
    </Box>
  );
};

export default BackToTopFAB;
